// src/services/vehicleService.js
import { apiClient } from './apiClient';

export const fetchVehicles = async () => {
  const xmlDoc = await apiClient('https://api.simracing.co.uk/v0.1/vehicles');
  return Array.from(xmlDoc.getElementsByTagName('vehicle')).map(vehicle => ({
    id: vehicle.getElementsByTagName('id')[0]?.textContent,
    name: vehicle.getElementsByTagName('name')[0]?.textContent,
  }));
};

export const fetchVehicleRecords = async (vehicleId) => {
  const xmlDoc = await apiClient(`https://api.simracing.co.uk/v0.1/vehicles/${vehicleId}/circuit_records`);
  return Array.from(xmlDoc.getElementsByTagName('result')).map(result => ({
    date: result.getElementsByTagName('date')[0]?.textContent,
    customerId: result.getElementsByTagName('customer_id')[0]?.textContent,
    customerName: result.getElementsByTagName('customer_name')[0]?.textContent,
    lapTimeStr: result.getElementsByTagName('lap_time_str')[0]?.textContent,
    venueName: result.getElementsByTagName('venue_name')[0]?.textContent,
    circuitName: result.getElementsByTagName('circuit_name')[0]?.textContent,
  }));
};
